import React from "react";
import PropTypes from "prop-types";

const CarIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  selected,
  ...props
}) => {
  const strokeColor = stroke && stroke !== "currentColor" ? stroke : color || "#666666";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={selected ? 1 : undefined}
      className={className}
      {...props}
    >
      <path
        d="M9.33301 12.0001V4.00008C9.33301 3.26419 8.73556 2.66675 7.99967 2.66675H2.66634C1.93045 2.66675 1.33301 3.26419 1.33301 4.00008V11.3334C1.33301 11.7014 1.63173 12.0001 1.99967 12.0001H3.33301"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12H6"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6663 11.9999H13.9997C14.3676 11.9999 14.6663 11.7012 14.6663 11.3333V8.89992C14.6661 8.74863 14.6144 8.60193 14.5197 8.48392L12.1997 5.58392C12.0734 5.42576 11.8821 5.33354 11.6797 5.33325H9.33301"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.0001C10 12.736 10.5974 13.3334 11.3333 13.3334C12.0692 13.3334 12.6667 12.736 12.6667 12.0001C12.6667 11.2642 12.0692 10.6667 11.3333 10.6667C10.5974 10.6667 10 11.2642 10 12.0001V12.0001"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33301 12.0001C3.33301 12.736 3.93045 13.3334 4.66634 13.3334C5.40223 13.3334 5.99967 12.736 5.99967 12.0001C5.99967 11.2642 5.40223 10.6667 4.66634 10.6667C3.93045 10.6667 3.33301 11.2642 3.33301 12.0001V12.0001"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "1.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

CarIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selected: PropTypes.bool,
};

CarIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
  selected: false,
};

export default CarIcon;
